/**
 * **실행 기록의 이름 — 규칙 하나**(D-125). 실행 기록이 보이는 자리(실행 목록 카드·검색·정렬·삭제 확인, 홈의 최근 활동,
 * 프로젝트 홈·모델 홈의 기록 표, 분석 화면의 기록 패널·적재 라벨, 재시작 원본 고르기, 모델의 «최근 실행 결과 보기»)는
 * 기록을 이것으로 부른다.
 *
 * 제목은 시작의 공통 길(`runStart.runTitleOf`)이 비지 않게 지키지만, 그 규칙 전에 제목 없이 남은 기록이 있다(BFF 이력의
 * 빈 제목 행). 그 기록은 이름을 지어내지 않고 짧게 보인 실행 id(`shortId`)로 부른다 — 전에는 자리마다 달라
 * 빈 칸·«Simulation»·날짜·«실행 결과 (id)»·전체 id 로 보였다.
 */
import type { SimulationEntry } from '@/types/project';
import { shortId } from '@/shared/shortId';

export function runEntryName(entry: Pick<SimulationEntry, 'id' | 'name'>): string {
  return entry.name.trim() || shortId(entry.id);
}
